export const modal = {
	methods: {
		// Add modal open class to body
		addModalBodyClass() {
			document.body.classList.add('modal-open');
		},
		// Remove modal open class to body
		removeModalBodyClass() {
			document.body.classList.remove('modal-open');
		},
	}
};